
































    import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import {QueryStandingBookDetail} from '../../../api/consumablesStock'


    @Component
    export default class Detail extends AbpBase{
        @Prop({type:Boolean,default:false}) value:boolean;
        @Prop({type:Object,default:{}}) data:object;
        // //会计期间检索
        // @Watch('periodDate')
        // WatchperiodDate(val: any, oldVal: any) { 
        //     this.queryItemSetDetailInfo()
        // }
        //日期范围检索
        @Watch('date')
        Watchdate(val: any, oldVal: any) { 
            this.queryItemSetDetailInfo()
        }
        actionType = 0 //操作类型
        actionTypeOptions = [
            {value:0,text:'全部'},
            {value:1,text:'入库'},
            {value:2,text:'出库'},
            // {value:3,text:'报损'},
            {value:4,text:'盘点'},
            // {value:5,text:'退货'},
            // {value:6,text:'调价'},
            {value:7,text:'红冲'},
        ]
        
        date:any = [];
	    // periodDate:any='';
        datas:any = this.data;
        details=[]
        table = {
            loading:false,
            totalCount : 0,
            pageSize : 10,
            currentPage:1
        }
        created() {
            console.log(this.datas)
            this.queryItemSetDetailInfo()
        }
        //获取详情
        async queryItemSetDetailInfo(){
            let data = {
                standingBookId:this.datas.id,
                consumableId:this.datas.consumableId,
                // tjqYear:this.periodDate==''?'':Util.dateConversion(this.periodDate).split('-')[0],
                // tjqMonth:this.periodDate==''?'':Util.dateConversion(this.periodDate).split('-')[1],
                startTime:this.date[0]?Util.dateConversion(this.date[0]):'',
                endTime:this.date[1]?Util.dateConversion(this.date[1]):'',
                actionType:this.actionType,
                pageSize:this.table.pageSize,
                page:this.table.currentPage
            }
            let res = await QueryStandingBookDetail(data)
            console.log(res)
            this.details = res.data.items
            this.table.totalCount = res.data.totalCount

        }
        typeChange(){
            this.date = [];
            // this.periodDate ='';
            this.table.currentPage = 1
            
            this.queryItemSetDetailInfo()
        }
        pageChange(page: number) {
            this.table.currentPage = page
            this.queryItemSetDetailInfo()
        }
        cancel(){
            (this.$refs.ruleForm as any).resetFields();
            this.$emit('input',false);
        }
        visibleChange(value:boolean){
            if(!value){
                this.$emit('input',value);
            }else{
            }
        }
        
        columns = [{
            title: "日期",
            key: 'validityPeriod',
            render: (h: any, params: any) => {
                return h('span',Util.formatTime(params.row.creationTime))
            }
        },{
            title: "操作类型",
            key: 'actionTypeName'
        },{
            title: "数量",
            key: 'quantity'
        },{
            title: "批号",
            key: 'batchNo'
        },{
            title: "有效日期",
            key: 'validityPeriod',
            render: (h: any, params: any) => {
                return h('span',Util.formatTime(params.row.validityPeriod))
            }
        }
        ,{
            title: "备注",
            key: 'remarks'
        }]
    }



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/consumablesStock/inventory/detail.vue